import Vue from "vue";
import Vuex from "vuex";
import VueResource from "vue-resource";
// import VuexPersist from "vuex-persist";
import VuexPersistence from "vuex-persist";
import Cookies from "js-cookie";

import user from "@/store/_user";
import others from "@/store/_others";
import layout from "@/store/_layout";
import message from "@/store/_message";
import log from "@/store/_log";

Vue.use(VueResource);
Vue.use(Vuex);

const storageKey = "sportsbook";

const localStorage = new VuexPersistence({
  key: storageKey,
  storage: window.localStorage,
  reducer: state => ({
    user: {
      platformLookUp: state.user.platformLookUp,
      gameTypeLookUp: state.user.gameTypeLookUp,
      leagueLookUp: state.user.leagueLookUp
    },
    layout: {
      language: state.layout.language,
      sidebar: state.layout.sidebar,
      pageSize: state.layout.pageSize,
      getSportType: state.layout.sportType,
      getLeagueID: state.layout.league,
      getMatchID: state.layout.match
    }
  })
});

const cookieStorage = new VuexPersistence({
  key: storageKey,
  restoreState: (key) => Cookies.getJSON(key),
  saveState: (key, state) =>
  Cookies.set(key, state, {
    expires: 3
  }),
  reducer: state => ({
    user: {
      login: state.user.login,
      account: state.user.account,
      profile: state.user.profile,
      access: state.user.access,
      ptList: state.user.ptList,
      cmList: state.user.cmList,
      blList: state.user.blList,
      wallet: state.user.wallet,
      platform: state.user.platform,
      credit_used_downline: state.user.credit_used_downline,
      scheduleList: state.user.scheduleList,
      match: state.user.match,
      subMatch: state.user.subMatch,
      betType: state.user.betType,
      tier: state.user.tier,
      selectedID: state.user.selectedID,
      selectedType: state.user.selectedType
    }
  })
});

const store = new Vuex.Store({
  modules: {
    user,
    others,
    layout,
    message,
    log
  },
  getters: {
    language: state => {
      return state.layout.language;
    },
    pageSize: state => {
      return state.layout.pageSize;
    },
    pageSizeOptions: state => {
      return state.layout.pageSizeOptions;
    },
    dateRange: state => {
      return state.layout.dateRange;
    },
    daterange: state => {
      return state.layout.daterange;
    },
    currentPageCategory: state => {
      return state.layout.currentPageCategory;
    },
    loginID: state => {
      return state.user.login.login_id;
    },
    profileID: state => {
      return state.user.profile.profile_id;
    },
    phone: state => {
      return state.user.profile.contact_phone || null;
    },
    email: state => {
      return state.user.profile.contact_email || null;
    },
    displayName: state => {
      if(state.user.profile.full_name) {
        return state.user.profile.full_name.replace(/\w\S*/g, function(txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
      } else {
        return null;
      }
    },
    authToken: state => {
      return state.user.login.auth_token;
    },
    isLoggedIn: state => {
      if (state.user.login.auth_token) {
        return true;
      } else {
        return false;
      }
    },
    authorityRole: state => {
      return state.user.login.authority_role;
    },
    accessRoles: state => {
      return state.user.access;
    },
    accountID: state => {
      return state.user.account.account_id;
    },
    accountType: state => {
      return state.user.account.account_type;
    },
    accountStatus: state => {
      return state.user.account.status;
    },
    cashMode: state => {
      return state.user.account.cash_mode;
    },
    securityTag: state => {
      return state.user.profile.security_tag;
    },
    securityDisabled: state => {
      return state.user.profile.security_disabled;
    },
    profileStatus: state => {
      return state.user.profile.status;
    },
    lastPasswordChanged: state => {
      return state.user.profile.last_password_changed;
    },
    getScheduleList: state => {
      return state.user.scheduleList;
    },
    paymentOptions: state => {
      return state.layout.paymentList;
    },
    accessOptions: state => {
      return state.layout.accessList;
    },
    getAccountCurrency: state => {
      return state.user.account.currency_code;
    },
    getCurrencyList: state => {
      return state.layout.currencyList;
    },
    getCommSBPackages: state => {
      if(state.user.cmList.cmSB) {
        return state.user.cmList.cmSB[0].hdp_packages;
        // if(state.user.cmList.cmSB[0].hdp_packages) {
        //   let packages = state.user.cmList.cmSB[0].hdp_packages.split(",");
        //   return packages;
        // }
      }
    },
    getCommSB: state => (group) => {
      if(state.user.cmList.cmSB) {
        return state.user.cmList.cmSB[0][group];
      }
    },
    getCommMmo: state => (group) => {
      if(state.user.cmList.cmMMO) {
        return state.user.cmList.cmMMO[0][group];
      }
    },
    getCommLC: state => {
      if(state.user.cmList.cmLC) {
        return state.user.cmList.cmLC[0].account_commission;
      }
    },
    getCommSL: state => {
      if(state.user.cmList.cmSL) {
        return state.user.cmList.cmSL[0].account_commission;
      }
    },
    getCommLO: state => {
      if(state.user.cmList.cmLO) {
        return state.user.cmList.cmLO[0].account_commission;
      }
    },
    getCommKN: state => {
      if(state.user.cmList.cmKN) {
        return state.user.cmList.cmKN[0].account_commission;
      }
    },
    getCommCF: state => {
      if(state.user.cmList.cmCF) {
        return state.user.cmList.cmCF[0].account_commission;
      }
    },
    getCommLT: state => {
      if(state.user.cmList.cmLT) {
        return state.user.cmList.cmLT;
      }
    },
    getCommMMO: state => {
      if(state.user.cmList.cmMMO) {
        return state.user.cmList.cmMMO;
      }
    },
    getCommTN: state => {
      if(state.user.cmList.cmTN) {
        return state.user.cmList.cmTN[0].account_commission;
      }
    },
    getBetLimit: state => {
      if(state.user.blList.blSB) {
        return state.user.blList.blSB;
      }
    },
    getBetLimitPackage: state => {
      if(state.user.blList.blLC) {
        return state.user.blList.blLC;
      }
    },
    getBetLimitPackageLO: state => {
      if(state.user.blList.blLO) {
        return state.user.blList.blLO;
      }
    },
    getBetLimitPackageKN: state => {
      if(state.user.blList.blKN) {
        return state.user.blList.blKN;
      }
    },
    getBetLimitPackageCF: state => {
      if(state.user.blList.blCF) {
        return state.user.blList.blCF;
      }
    },
    getBetLimitPackageLT: state => {
      if(state.user.blList.blLT) {
        return state.user.blList.blLT;
      }
    },
    getPTSB: state => {
      if(state.user.ptList.ptSB) {
        return state.user.ptList.ptSB;
      }
    },
    getPTLC: state => {
      if(state.user.ptList.ptLC) {
        return state.user.ptList.ptLC;
      }
    },
    getPTSL: state => {
      if(state.user.ptList.ptSL) {
        return state.user.ptList.ptSL;
      }
    },
    getPTLO: state => {
      if(state.user.ptList.ptLO) {
        return state.user.ptList.ptLO;
      }
    },
    getPTKN: state => {
      if(state.user.ptList.ptKN) {
        return state.user.ptList.ptKN;
      }
    },
    getPTCF: state => {
      if(state.user.ptList.ptCF) {
        return state.user.ptList.ptCF;
      }
    },
    getPTLT: state => {
      if(state.user.ptList.ptLT) {
        return state.user.ptList.ptLT;
      }
    },
    getAccountCreditLimit: state => {
      if(state.user.wallet.info) {
        return state.user.wallet.info[0].credit_limit;
      }
    },
    getAccountCashBalance: state => {
      if(state.user.wallet.info) {
        return state.user.wallet.info[0].cash_balance;
      }
    },
    getAccountBalance: state => {
      if(state.user.wallet.info) {
        return state.user.wallet.info[0].account_balance;
      }
    },
    getAccountOutstandingBalance: state => {
      if(state.user.wallet.info) {
        return state.user.wallet.info[0].outstanding_balance;
      }
    },
    getAccountMemberCreditLimit: state => {
      if(state.user.wallet.info) {
        return state.user.wallet.info[0].member_credit_limit;
      }
    },
    getCreditUsedDownline: state => {
      return state.user.credit_used_downline;
    },
    getPlayerAlert: state => {
      return state.user.alert;
    },
    getPlayerAlertCall: state => {
      return state.user.alertCall;
    },
    overviewPopup: state => {
      return state.user.overviewPopup;
    },
    getTier: state => {
      return state.user.tier;
    },
    getSelectedID: state => {
      return state.user.selectedID;
    },
    getSelectedType: state => {
      return state.user.selectedType;
    },
    getSubMatch: state => {
      return state.layout.subMatch;
    },
    getBetType: state => {
      return state.layout.betType;
    },
    getFullAmount: state => {
      return state.layout.fullAmount;
    },
    getPlatform: state => {
      return state.layout.platform;
    },
    getPlatformLookUp: state => {
      return state.user.platformLookUp;
    },
    getGameTypeLookUp: state => {
      return state.user.gameTypeLookUp;
    },
    getLeagueLookUp: state => {
      return state.user.leagueLookUp;
    },
    getSportType: state => {
      return state.layout.sportType;
    },
    getLeagueID: state => {
      return state.layout.league;
    },
    getMatchID: state => {
      return state.layout.match;
    },
    getPageDetail: state => {
      return state.layout.pageDetail;
    },
    getBetListDetail: state => {
      return state.layout.betListDetail;
    },
    getPlatformList: state => {
      if (state.user.platform) {
        return state.user.platform.platform;
      }
    },
    isSlotPlatformEnabled: state => {
      if (state.user.platform) {
        return state.user.platform.platform[1].enable_platform;
      }
    },
    isLivecasinoPlatformEnabled: state => {
      if (state.user.platform) {
        return state.user.platform.platform.filter(x => x.platform_code == 'LIVECASINO');
      }
    }
  },
  // plugins: [cookieStorage.plugin]
  plugins: [localStorage.plugin, cookieStorage.plugin]
});

export default store;
